module.exports = __webpack_public_path__ + "img/jnd.0da19ffb.jpg";